<template>
  <div>
    <a-layout id="components-layout-demo-side" style="background: white;">
      <a-layout-sider style="height:100%;padding:10px;" width="120px">
        <SelectTree
          ref="myTree"
          :option="treeOption"
          @selectedTree="receiveData"
        />
      </a-layout-sider>
      <a-layout style="background: white;padding:10px">
        <a-row style="padding-bottom:20px">
          <a-col :span="8">
            <a-button
              type="primary"
              style="margin-right:10px"
              @click="checkInfo"
            >
              查看
            </a-button>
            <a-button
              type="primary"
              style="margin-right:10px"
              :disabled="intoLock"
              @click="getIntoFavour"
              :loading="intoLoadingState"
            >
              添加到我的收藏
            </a-button>
            <a-button
              type="primary"
              style="margin-right:10px"
              :disabled="outtoLock"
              @click="getOutFavour"
              :loading="outtoLoadingState"
            >
              从我的收藏移除
            </a-button>
          </a-col>
          <a-col :span="16" style="text-align:right">
            <a-form layout="inline" :form="form" @submit="onSearch">
              <a-form-item>
                <a-input
                  placeholder="请输入名称/代码"
                  style="width: 200px;"
                  ref="searchName"
                  v-decorator="[
                    'dateSelect',
                    {
                      initialValue: defaultDateValue
                    }
                  ]"
                />
              </a-form-item>
              <a-form-item>
                <a-button type="primary" html-type="submit">
                  查询
                </a-button>
              </a-form-item>
            </a-form>
          </a-col>
        </a-row>
        <data-grid
          ref="myGrid"
          :api="gridApi"
          :params="gridParams"
          :columns="columns"
          v-model="data"
          :rowKey="rowKey"
          bordered
          @selectRow="onListTableSelectRow"
          :pagination="true"
          :pageSize="10"
        >
        </data-grid>
      </a-layout>
    </a-layout>
  </div>
</template>

<script>
import SelectTree from "@/components/dataTree/SelectTree";
import { DataGrid } from "@/components/dataGrid";
import { cache } from "@/utils/common";
import ReportCenterTableModal from "./funtion.js";
import $config from "@/config/baseConfig";

export default {
  components: {
    SelectTree,
    DataGrid
  },
  data() {
    return {
      reportModal: false,
      option: {},
      treeSelectCode: "",
      rowKey: "Id",
      form: this.$form.createForm(this),
      defaultDateValue: "",
      gridApi: "",
      gridParams: {},
      columns: [
        {
          title: "序号",
          width: "80px", //宽度
          align: "center", //对齐方式
          type: "indexcolumn" // 类型，indexcolumn = 序号
        },
        {
          title: "代码",
          dataIndex: "Code",
          align: "center",
          width: "200px"
        },
        {
          title: "名称",
          dataIndex: "Name",
          align: "center",
          width: "200px"
        },
        {
          title: "报表说明",
          dataIndex: "Description",
          align: "center"
        }
      ],
      data: [],
      selectedRowKeys: [],
      backUrl: "",
      outtoLock: false,
      intoLock: true,
      extendsTree: {
        Id: "-1",
        Name: "我的收藏",
        key: "-1",
        scopedSlots: { title: "title" },
        title: "我的收藏"
      },

      isSelectFavor: true,
      intoLoadingState: false,
      outtoLoadingState: false,

      treeOption: {
        //URL数据请求地址
        api: "GroupRole_GetReportGroupsAsync",
        //数据字段
        dataField: "Data",
        //标题字段
        title: "Name",
        //子数组字段
        children: "Childs",
        //选择值字段
        keyValue: "Id",
        //使用模式
        checkMode: "parentMode",
        //额外树项目添加
        extraTreeData: {
          Id: "-1",
          Name: "我的收藏",
          key: "-1",
          scopedSlots: { title: "title" },
          title: "我的收藏"
        },
        params: { From: "reportcenter" }
      }
    };
  },
  created() {
    this.user = cache.get("user");
  },
  methods: {
    receiveData(Data) {
      this.treeSelectCode = Data.treeSelect;
      var searchName = this.$refs.searchName.value;
      if (Data.treeSelect == "-1") {
        this.isSelectFavor = true;
        this.outtoLock = false;
        this.intoLock = true;
        this.gridApi = "UserFavorReport_List";
        this.gridParams = {
          PageIndex: 0,
          PageSize: 10,
          Name: searchName
        };
      } else {
        this.isSelectFavor = false;
        this.outtoLock = true;
        this.intoLock = false;

        this.gridApi = "ReportMaintenance_List";
        this.gridParams = {
          PageIndex: 0,
          PageSize: 10,
          ReportGroupId: Data.treeSelect,
          Name: searchName
        };
      }
    },
    checkInfo() {
      let row = this.$refs.myGrid.getSelected();
      if (!row) {
        this.$message.info("请选择报表!");
        return;
      }
      let serverUrl = $config.serverUrl;
      let url =
        this.user.ReportUrl +
        "/show?reportid=" +
        row.Code +
        "&url=" +
        serverUrl.substring(serverUrl.lastIndexOf("//") + 2, serverUrl.length) +
        "&Token=" +
        this.user.Token;
      ReportCenterTableModal({ title: "报表信息", width: "100%", url: url });
      // _this.$router.push({
      //   path: "/reportCenter/reportCenterTable",
      //   query: {
      //     reportid: row.Code,
      //     url: "139.9.66.78:7030"
      //   }
      // });
    },
    getIntoFavour() {
      var _this = this;
      if (!_this.$refs.myGrid.gridSelectedRow) {
        _this.$message.info("请选择报表!");
        return;
      }
      _this
        .$post("UserFavorReport_Add", {
          ReportId: _this.$refs.myGrid.gridSelectedRow.Id
        })
        .then(() => {
          _this.$refs.myGrid.reload();
          _this.$message.info("已加入我的收藏");
        });
    },
    getOutFavour() {
      var _this = this;
      if (!_this.$refs.myGrid.gridSelectedRow) {
        _this.$message.info("请选择报表!");
        return;
      }
      _this
        .$post("UserFavorReport_Delete", {
          Id: _this.$refs.myGrid.gridSelectedRow.Id
        })
        .then(() => {
          _this.$refs.myGrid.reload();
          _this.$message.info("已从我的收藏移除");
        });
    },
    onSearch(e) {
      var _this = this;
      e.preventDefault();
      _this.form.validateFields((err, values) => {
        if (!err) {
          if (_this.treeSelectCode == "-1") {
            let item = { Name: values.dateSelect, PageIndex: 0, PageSize: 10 };
            _this.$post("UserFavorReport_List", item).then(res => {
              _this.data = res.Data.Datas;
            });
          } else {
            let item = {
              Name: values.dateSelect,
              PageIndex: 0,
              PageSize: 10,
              ReportGroupId: _this.treeSelectCode
            };
            _this.$post("ReportMaintenance_List", item).then(res => {
              _this.data = res.Data.Datas;
            });
          }
        }
      });
    },
    onListTableSelectRow(e) {
      const _this = this;
      if (e.IsFavor == true) {
        _this.outtoLock = true;
        _this.intoLock = true;
      } else if (e.IsFavor == false) {
        _this.outtoLock = true;
        _this.intoLock = false;
      }
    },
    onSubmit() {}
  }
};
</script>

<style lang="less" scoped>
.ant-layout-sider {
  -webkit-transition: all 0.2s;
  transition: all 0.2s;
  position: relative;
  background: white;
  min-width: 0;
}
</style>
